import { encodeFunctionData } from "viem";

import { ERC20_APPROVE_ABI } from "./abis";
import { MAX_UINT256 } from "./constants";

import type { DeployContext } from "../deployer/deploy-utils";
import type { Address } from "viem";

/** Approve a spender for a given ERC-20 token. */
export async function approveToken(
  ctx: DeployContext,
  token: Address,
  spender: Address,
  amount: bigint = MAX_UINT256,
  account?: Address,
): Promise<void> {
  const data = encodeFunctionData({
    abi: ERC20_APPROVE_ABI,
    functionName: "approve",
    args: [spender, amount],
  });
  await ctx.walletClient.sendTransaction({
    account: account ?? ctx.deployer,
    to: token,
    data: data,
    chain: ctx.walletClient.chain,
  });
}
